import React from 'react';
import { Grid2 as Grid } from '@mui/material';
import CommercialControl from 'domain/projects/newProject/controls/commercial/CommercialControl';
import EngineeringControl from 'domain/projects/newProject/controls/engineering/EngineeringControl';
import ProjectManagementControl from 'domain/projects/newProject/controls/projectManagement/ProjectManagementControl';
import StaffingControl from 'domain/projects/newProject/controls/staffing/StaffingControl';
import { ControlData } from 'domain/projects/newProject/controls/types';
import { useControlSlices } from 'domain/projects/newProject/controls/useControlSlices';
import { useDashboardProjectDataContext } from '../../context/DashboardProjectContext';
import { ProjectData, ProjectDataContext } from 'domain/shared/newProject';

const ProjectDashboardControls = () => {
  const { data: project, refetch } = useDashboardProjectDataContext();
  const controlData = project as unknown as ControlData;
  const { refetchCommercialData, refetchProjectManagementData } = useControlSlices(controlData.id);
  const projectDataContextValue = {
    data: project as unknown as ProjectData,
    refetch: async () => (await refetch()) as ProjectData | undefined,
  };

  return (
    <ProjectDataContext.Provider value={projectDataContextValue}>
      <Grid container columns={12} spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <CommercialControl data={controlData} refetchControlsData={refetchCommercialData} showSections={false} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ProjectManagementControl
            data={controlData}
            refetchControlsData={refetchProjectManagementData}
            showSections={false}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <EngineeringControl data={controlData} showSections={false} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <StaffingControl data={controlData} showSections={false} />
        </Grid>
      </Grid>
    </ProjectDataContext.Provider>
  );
};

export default ProjectDashboardControls;
